// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".form-add-grupo__table .vs__deselect[data-v-9e3ce67c]{fill:#fff}", ""]);
// Exports
module.exports = exports;
